import React from "react";

import styles from "./Hero.module.scss";

export const Hero = function ({ scrollTo }) {
  return (
    <section id="form" className={styles.hero}>
      <div className={styles.heroContainer}>
        <h1>ARTIFICIAL INTELLIGENCE IN HEALTH CARE</h1>
        <small>ONLINE SHORT COURSE</small>
        <p>
          Nearly every industry is looking to leverage the power of AI, and health care is no exception. Understand the
          applications, opportunities, and transformative potential of AI in your health care context.
        </p>
        <button onClick={scrollTo} id="cta-scroll">
          GET MORE INFORMATION
        </button>
      </div>
    </section>
  );
};
